/**
 * Utilidades para restricciones de equipos basadas en fechas
 */

const restrictionDate = new Date('2025-09-17T00:00:00.000Z').getTime();

/**
 * Verifica si un equipo fue creado desde la fecha de restricción
 * @param {Object} team - Objeto del equipo
 * @returns {boolean} - true si el equipo fue creado desde hoy
 */
export const isCreatedAfterRestrictionDate = (team) => {
  if (!team || !team.createdAt) {
    return false;
  }
  
  const teamCreatedAt = team.createdAt;

  return teamCreatedAt >= restrictionDate;
};

/**
 * Verifica si un equipo puede acceder al módulo de recetas
 * @param {Object} team - Objeto del equipo
 * @param {Object} resource - Objeto del resource (opcional)
 * @returns {boolean} - true si el equipo puede acceder al módulo de recetas
 */
export const canResourceAccessPrescriptions = (team, resource = null) => {
  // Si el equipo fue creado antes de la fecha de restricción, puede acceder normalmente
  if (!isCreatedAfterRestrictionDate(team)) {
    return true;
  }

  // Si el equipo fue creado desde la fecha de restricción, necesita que el resource tenga la marca
  return resource?.canCreatePrescriptions === true;
};

/**
 * Verifica si un equipo puede acceder al módulo de órdenes médicas.
 * Flag independiente de recetas (canCreatePrescriptions).
 * @param {Object} team - Objeto del equipo
 * @param {Object} resource - Objeto del resource (opcional)
 * @returns {boolean} - true si el equipo puede acceder al módulo de órdenes
 */
export const canResourceAccessOrders = (team, resource = null) => {
  if (!isCreatedAfterRestrictionDate(team)) {
    return true;
  }

  return resource?.canCreateOrders === true;
};
